import { render } from "./AdminTopbar.vue?vue&type=template&id=9b23a194&scoped=true"
import script from "./AdminTopbar.vue?vue&type=script&lang=js"
export * from "./AdminTopbar.vue?vue&type=script&lang=js"

import "./AdminTopbar.vue?vue&type=style&index=0&id=9b23a194&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b23a194"]])

export default __exports__